import styled from 'styled-components';
import { Overline, spacing } from 'ui/theme';
import { HelpTooltip } from 'ui/tooltip';

const Row = styled.div`
  display:flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const TableHeaderCell = ({
  name,
  tooltipContent,
}: { name: string; tooltipContent: string }) => (
  <Row>
    <Overline>{name}</Overline>
    <HelpTooltip
      automaticallyAvoidCollisions
      iconProps={{ height: 16, width: 16, isColorInherited: true }}
      tooltipContent={tooltipContent}
    />
  </Row>
);
